import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export const PageLoader = () => {
	return (
		<Box
			sx={{
				display: "flex",
				position: "absolute",
				top: 0,
				bottom: 0,
				height: "100vh",
				width: "100%",
				alignItems: "center",
				justifyContent: "center",
				zIndex: -1,
			}}
		>
			<CircularProgress size="10rem" />
		</Box>
	);
};
